import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './routes/app.routes';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr } from 'ngx-toastr';
import { provideEchartsCore } from 'ngx-echarts';

import { httpErrorInterceptorProvider } from './core/interceptors/http-error.interceptor';
export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),
    provideAnimations(),
    provideToastr({
      preventDuplicates: true,
      timeOut: 3000,
    }),
    httpErrorInterceptorProvider,
    provideEchartsCore({ echarts: () => import('echarts') }),
  ],
};
